import { render, staticRenderFns } from "./CPU_utilization_top10.vue?vue&type=template&id=60e5d67a"
import script from "./CPU_utilization_top10.vue?vue&type=script&lang=js"
export * from "./CPU_utilization_top10.vue?vue&type=script&lang=js"
import style0 from "./CPU_utilization_top10.vue?vue&type=style&index=0&id=60e5d67a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports